import React, { memo } from "react";
import { observer } from "mobx-react";
import PopupForm from "app/common/Component/Popup/PopupForm";
import { Grid, Tooltip } from "@material-ui/core";
import TableComponent from "app/common/Component/Table/TableComponent";
import { useTranslation } from "react-i18next";
import { VOUCHER_STATUS } from "app/common/LocalConst";
import {
  formatMoney,
  formatNumber,
  getDateTime,
} from "app/common/LocalFunction";
import LockIcon from "@material-ui/icons/Lock";
import LockOpenIcon from "@material-ui/icons/LockOpen";
function HistoryStaffRevenuePopup({
  open,
  handleClose,
  searchData,
  pageStaffRevenueHistory,
  handleChangeFormSearch,
}) {
  const { t } = useTranslation();

  return (
    <PopupForm
      size="lg"
      title="Lịch sử chỉnh sửa phân bổ"
      open={open}
      handleClose={handleClose}
      formik={{
        initialValues: searchData,
      }}
      hideSubmit
    >
      <Grid container spacing={1}>
        <Grid
          item
          xs={12}
          className="justify-center cards-body pt-0 mt-2"
          style={{
            zIndex: 1,
            position: "relative",
          }}
        >
          <TableComponent
            className=""
            showOrdinalNumbers
            titleNodata={t("noData")}
            data={pageStaffRevenueHistory?.content}
            name="HistoryStaffRevenue"
            showMoreButton
            minWidth={"1000"}
            columns={[
              {
                title: t("Mã nhân viên"),
                field: "staffCode",
              },
              {
                title: t("Tên nhân viên"),
                field: "staffName",
              },
              {
                title: t("Tên nguồn"),
                field: "sourceName",
              },
              {
                title: t("Phân bổ doanh thu (%)"),
                field: "price",
                render: (row) => formatMoney(row?.percentRevenue),
              },
              {
                title: t("Phân bổ doanh thu (tiền)"),
                field: "price",
                render: (row) => formatMoney(row?.actualAmount),
              },
              {
                title: t("Cơ sở"),
                field: "departmentName",
              },
              {
                title: t("Trạng thái"),
                field: "locked",
                align: "center",
                render: (row) => {
                  const isLocked = row?.locked === true; // chỉ true khi thật sự bị khóa
                  return (
                    <Tooltip title={isLocked ? "Đã khóa" : "Đang mở"}>
                      {isLocked ? <LockIcon /> : <LockOpenIcon />}
                    </Tooltip>
                  );
                },
              },
              {
                field: "createdBy",
                title: t("Người tạo"),
              },
              {
                field: "modifiedBy",
                title: t("Người sửa"),
              },
              {
                field: "modifyDate",
                title: t("Thời gian sửa (theo hệ thống)"),
                render: (row) => getDateTime(row?.modifyDate),
              },
              {
                title: t("Ghi chú"),
                field: "note",
              },
            ].filter(Boolean)}
            dataPagination={{
              pageIndex: searchData?.pageIndex,
              pageSize: searchData?.pageSize,
              totalElements: pageStaffRevenueHistory?.totalElements,
              totalPages: pageStaffRevenueHistory?.totalPages,
              setPageIndex: (pageIndex) =>
                handleChangeFormSearch({ pageIndex }),
              setPageSize: (pageSize) => handleChangeFormSearch({ pageSize }),
            }}
          />
        </Grid>
      </Grid>
    </PopupForm>
  );
}

export default memo(observer(HistoryStaffRevenuePopup));
